/* tslint:disable:no-any */
/**
 * User defined context that provides more information about the log event.
 *
 * NOTE: The status service is used to also add information about the current user and organization.
 */
export interface ILogContext extends Record<string, any> {
}

/**
 * User defined context that provides more information about the log event.
 */
export interface IExceptionLogContext extends ILogContext {
  /** The caught exception. */
  exception: NonNullable<unknown>;
}

export function isLogContextWithException(context: ILogContext): context is IExceptionLogContext {
  if (!context.hasOwnProperty('exception')) {
    return false;
  }
  return (context as { exception: unknown }).exception != null;
}

export interface ILogClientContext {
  clientId: string;
  clientVersion: string;
}

export interface ILogUserContext {
  userId: string;
  userName: string;
}

export interface ILogOrganizationContext {
  organizationId: string;
  organizationName: string;
}
